<template v-if="!isAuthenticated">
  <div class="iFrame">
    <iframe ref="iframeTop" class="dynamic-iframe" :src="iframe1URL" scrolling="no"/>
  </div>
  <div class="connect">
    <template v-if="!isAuthenticated">
      <div class="login-section">
          <form @submit.prevent="submitLogin" class="compact-form">
              <div class="input-group">
              <label for="username" class="input-label">Nom d'utilisateur ou Email <!-- <span> max 50 caractères</span> --></label>
              <input v-model="username" type="text" class="input-control" id="username" placeholder="Email ou nom d'utilisateur" autocomplete="username" :maxlength="getMaxLength('username')">
              </div>
  
              <div class="input-group">
              <label for="password" class="input-label">Mot de passe <!-- <span> max 100 caractères</span> --></label>
              <div class="password-wrapper">
                  <input v-if="showPassword" v-model="password" type="text" class="input-control" id="password" placeholder="Mot de passe" autocomplete="current-password" :maxlength="getMaxLength('password')">
                  <input v-else v-model="password" type="password" class="input-control" id="password" placeholder="Mot de passe" autocomplete="current-password" :maxlength="getMaxLength('password')">
                  <div @click="toggleShow" class="eye-icon">
                  <i class="bi" :class="{ 'bi-eye-slash-fill': showPassword, 'bi-eye-fill': !showPassword }"></i>
                  </div>
              </div>
              </div>
              
              <div class="form-footer">
                <button type="submit">Se connecter</button>
              </div>
          </form>
        <div class="register-link">
            <router-link to="/register">Pas encore de compte ? Créez-le ici</router-link>
        </div>
        <div class="register-link">
            <router-link to="/forget">Mot de passe oublié ?</router-link>
        </div>
      </div>
    </template>
  </div>
  <div class="iFrame">
    <iframe ref="iframeBottom" class="dynamic-iframe" :src="iframe2URL" scrolling="no"/>
  </div>
</template>
  
  <script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import '../../assets/styles/modal.css'
  import '../../assets/styles/base.css'
  
  export default {
    name: "LoginView",
    data() {
      return {
        username: "",
        password: "",
        showPassword: false,
        bottomURL: "",
        iframe1URL: (window.__APP_CONFIG__?.VUE_APP_IFRAME1_URL || "https://www-vali.lausanne.ch/hors-arbo/smeo-1/contentAutogenerated/autogeneratedContainer/col1/00"),
        iframe2URL: (window.__APP_CONFIG__?.VUE_APP_IFRAME2_URL || "https://www-vali.lausanne.ch/hors-arbo/smeo-2/contentAutogenerated/autogeneratedContainer/col1/00"),
        resizeTimeout: null,
        lastWindowWidth: 0,
      }
    },
    computed: {
      ...mapState('auth', ['isAuthenticated', 'user', 'respStatus']),
      ...mapState('referential', ['maxLength']),
      ...mapGetters('referential', ['getMaxLength']),
    },
    mounted() {
      this.lastWindowWidth = window.innerWidth;
      window.addEventListener("message", this.myEventHandler);
      window.addEventListener("resize", this.handleWindowResize);
    },

    unmounted() {
      window.removeEventListener("message", this.myEventHandler);
      window.removeEventListener("resize", this.handleWindowResize);
      clearTimeout(this.resizeTimeout);
    },

    methods: {
      ...mapActions('auth', ['logout', 'login']),
      
      toggleShow() {
        this.showPassword = !this.showPassword;
      },
      myEventHandler(event) {
        const data = event.data;

        if (!data || data.type !== "iframe-height") return;

        const height = Number(data.height);
        if (!Number.isFinite(height)) return;

        const top = this.$refs.iframeTop;
        const bottom = this.$refs.iframeBottom;

        if (top && top.contentWindow === event.source) {
          top.style.height = height + "px";
          return;
        }

        if (bottom && bottom.contentWindow === event.source) {
          bottom.style.height = height + "px";
          return;
        }
      },
      handleWindowResize() {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          const top = this.$refs.iframeTop;
          const bottom = this.$refs.iframeBottom;

          if (top) {
          top.style.height = '10px'; 
          //eslint-disable-next-line
          top.src = top.src;
        }
        
        if (bottom) {
          bottom.style.height = '10px';
          //eslint-disable-next-line
          bottom.src = bottom.src;
        }
        }, 300);
      },
      async submitLogin() {
        try {
          /* const response =  */await this.login({
            username: this.username,
            password: this.password
          });
          this.$router.push('/home');
          /* if (response.status === 200) {
            //console.log("response :", response)
            } */
          }  catch (error) {
            //console.log("_erreur", error )
        let message = error || 'Erreur';
            if (message === 'Invalid login')message="Mot de passe ou nom d'utilisateur invalide";
            else if (message === 'You must supply a login and password !')message="Vous devez remplir tout les champs !";
          alert(error);
        throw error;
        }
        }
      },
      async handleLogout() {
        await this.logout();
        /* //console.log("Logging out", this.isAuthenticated, this.token, this.username) */
        this.$router.push('/login');
      },
  };
  </script>
  
  <style scoped>

  .connect {
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }
  
  .login-section {
    max-width: 450px;
    width: 100%;
  }
  
  .compact-form {
    padding: 14px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(255, 172, 172, 0.5);
    margin-bottom: 16px;
  }
  
  .input-group {
    margin-bottom: 16px;
  }
  
  .input-label {
    font-weight: 600;
    font-size: 0.9rem;
    display: block;
    margin-bottom: 4px;
    color: #2c3e50;
  }
  
  .input-control {
    width: 100%;
    padding: 8px 12px;
    font-size: 0.9rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: rgba(245, 245, 245, 0.031);
  }
  
  .password-wrapper {
    position: relative;
    display: flex;
  }
  
  .password-wrapper .input-control {
    flex: 1;
    padding-right: 40px;
  }
  
  .eye-icon {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  
  .bi {
    font-size: 1rem;
    color: var(--text-color);
    padding: 0 12px;
  }
  
  .form-footer {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }

  .iFrame {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    width: 100%;
    height: 100%;

  }

  .dynamic-iframe {
      width: 100%;
      border: none;
      overflow: hidden;
  }

  button{
    padding: 1vh 1.75vw;
  }
  
  a {
    color: var(--primary-color);
    text-decoration: none;
    transition: all 0.3s ease;
    margin: 8px 0 0 75px;
    text-align: center;
  }
  
  a:hover {
    color: var(--primary-color);
    text-decoration: underline;
  }

  .register-link {
    text-align: center;
    margin: 16px 75px 0 0;
  }
  </style>